<template>
  <el-dialog title='完善价格' :visible.sync='dialogVisible' :close-on-click-modal='false' width='910px'>
    <div-border label='价格设置'>
      <el-form :model='dialogForm' label-width='100px'>
        <el-form-item label='结算方式：' style='margin-top: 15px' v-if='dialogForm.isWay !== 1'>
              <span style='display:inline-block;width:320px'>
                <el-radio-group v-model='dialogForm.type'>
                  <el-radio :label='0'>暂无</el-radio>
                  <el-radio :label='1'>合同价格</el-radio>
                  <el-radio v-if='dialogForm.isWay === -1' :label='2'>预结算价格</el-radio>
                </el-radio-group>
              </span>
          <span
            style='display:inline-block;width:calc(100% - 320px);text-align:right;padding-right:15px;'>
                <el-input size='small' v-if='dialogForm.type!==0' v-model='dialogForm.price'
                          placeholder='请输入价格' />
              </span>
        </el-form-item>
        <el-form-item label='预估价：' v-if='dialogForm.isEst'
                      style='width:calc(100% - 250px);display:inline-block;'
                      :style="dialogForm.isWay === 1? 'margin-top:15px;' : ''">
          <el-input size='small' v-model='dialogForm.estimate' placeholder='请输入预估价' />
        </el-form-item>
        <el-form-item label-width='0px'
                      style='width:250px;text-align:right;display:inline-block;'
                      :style="!dialogForm.isEst?'width:100%;':''">
          <el-button size='small' class='searchBtn' @click='dialogSubmit'>确定</el-button>
          <el-button size='small' class='resetBtn' @click='dialogVisible = false'>取消
          </el-button>
        </el-form-item>
      </el-form>
    </div-border>
    <div-border :is-need='true' v-if='dialogForm.isWay !== 1 && dialogForm.type !== 0'
                label='选择合同' class='p20'>
      <div style='display: flex'>
        <div class='navContainer'>
          <p>合同名称：</p>
          <el-input v-model='searchForm.contractName' size='mini' style='width:150px'
                    placeholder='请输入合同名称' />
        </div>
        <div class='navContainer'>
          <p>合同编号：</p>
          <el-input v-model='searchForm.codeNumber' size='mini' style='width:150px'
                    placeholder='请输入合同编号' />
        </div>
        <div class='navContainer'>
          <p>签约单位：</p>
          <el-input v-model='searchForm.companyName' size='mini' style='width:150px'
                    placeholder='请输入签约单位' />
        </div>
        <div class='navBtn'>
          <el-button size='small' class='searchBtn' @click='getTableData'>查询</el-button>
          <el-button size='small' class='resetBtn' @click='reset'>重置</el-button>
        </div>
      </div>
      <el-table :data='tableData' highlight-current-row border ref='contractTable'
                @current-change='contractChange' v-loading='tableLoading'
                :header-cell-style="{color:'#3B3B3B','font-weight':'700','padding':'0px','font-size':'13px',height:'35px',background:'#E8E8E8',}"
                :cell-style="{ color:'#7F7F7F','font-size':'13px' }">
        <el-table-column type='index' width='50' />
        <el-table-column property='codeNumber' label='合同编号' min-width='150' align='center' />
        <el-table-column property='contractName' label='合同名称' min-width='150' align='center' />
        <el-table-column property='typeName' label='合同类型' min-width='100' align='center' />
        <el-table-column property='companyName' label='签约单位' min-width='150' align='center' />
        <el-table-column property='startDate' label='开始日期' min-width='100' :formatter='dateFormat'
                         align='center' />
        <el-table-column property='endDate' label='结束日期' min-width='100' :formatter='dateFormat'
                         align='center' />
      </el-table>
      <div style='margin-top: 20px'>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='completeSizeChange'
          @current-change='completeCurrentChange'
          :current-page.sync='searchForm.page'
          :page-size='searchForm.rows'
        />
      </div>
    </div-border>
  </el-dialog>
</template>

<script>
  import { completePrice, contractPageList } from '@/service/financial';
  import divBorder from '@/components/divBorder';
  import { portWarehouseSupplierPriceSettingPerfect } from '@/service/warehouse';

  export default {
    name: 'perfectPrice',
    components: { divBorder },
    data() {
      return {
        dialogVisible: false,
        dialogTitle: '新增',
        defaultDialogForm: {},
        dialogForm: {},
        defaultSearchForm: {},
        searchForm: {
          id: '',
          codeNumber: '',   // 合同编号
          contractName: '',   // 合同名称
          companyName: '',    // 签约单位
          page: 1,
          rows: 10,
        },
        total: 0,
        tableData: [],
        tableLoading: false,
        submitLoading: false,
        selectContract: {},
      };
    },
    methods: {
      completeSizeChange(rows) {
        this.searchForm.rows = rows;
        this.searchForm.page = 1;
        this.getTableData();
      },
      completeCurrentChange(page) {
        this.condition.page = page;
        this.getTableData();
      },
      // 时间长度处理
      dateFormat(row, column, cellValue) {
        if (cellValue) {
          return cellValue.substring(0, 10);
        } else {
          return '';
        }
      },
      contractChange(val) {
        this.selectContract = val;
      },
      dialogOpen(row) {
        this.dialogForm = {
          id: row.id,
          isWay: row.isPerfectPrice,
          isEst: !row.estimatePrice,
          customerId: row.customerId,
          type: 0,
          price: '',
          estimate: row.estimatePrice || '',
        };
        if (row.isPerfectPrice === 0) this.dialogForm.price = row.contractPrice;
        row.contractId ? this.selectContract = { id: row.contractId } : this.selectContract = '';
        this.searchForm.id = row.customerId;
        this.defaultDialogForm = JSON.parse(JSON.stringify(this.dialogForm));
        this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
        this.dialogVisible = true;
        this.getTableData();
      },
      dialogClose() {
        this.dialogVisible = false;
        this.dialogForm = JSON.parse(JSON.stringify(this.defaultDialogForm));
      },
      async getTableData() {
        this.tableLoading = true;
        let res = await contractPageList(this.searchForm);
        this.tableLoading = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.tableData = res.data;
        this.total = res.data.total || 0;
        if (this.selectContract.id && this.tableData.length > 0) {
          this.tableData.forEach(item => {
            if (item.id === this.selectContract.id) {
              if (this.$refs.contractTable) this.$refs.contractTable.setCurrentRow(item);
            }
          });
        }
      },
      reset() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
      },
      // 完善价格 —— 确认
      async dialogSubmit() {
        if (this.dialogForm.type === 1 && (!this.dialogForm.price || this.dialogForm.price === '')) {
          return this.$message.warning('请输入价格！');
        }
        if (this.dialogForm.type === 1 && (!this.selectContract.id || this.selectContract.id === '')) {
          return this.$message.warning('请选择合同！');
        }
        let obj = '?id=' + this.dialogForm.id;
        if (this.dialogForm.isWay !== 1 && this.dialogForm.type === 1) {
          obj += '&contractId=' + this.selectContract.id;
          obj += '&contractPrice=' + this.dialogForm.price;
        }
        if (this.dialogForm.isWay === -1 && this.dialogForm.type === 2) {
          obj += '&preparePrice=' + this.dialogForm.price;
          if (this.selectContract.id && this.selectContract.id !== '') {
            obj += '&contractId=' + this.selectContract.id;
          }
        }
        if (this.dialogForm.isEst && this.dialogForm.estimate) {
          obj += '&estimatePrice=' + this.dialogForm.estimate;
        }
        let res = await portWarehouseSupplierPriceSettingPerfect(obj);
        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        this.dialogVisible = false;
        await this.$emit('searchBtn');
      },
    },
  };
</script>

<style lang='scss' scoped>

  .navContainer {
    display: inline-block;
    width: 230px;
    text-align: center;

    p {
      display: inline-block;
      width: 70px;
    }
  }

  .navBtn {
    display: inline-block;
    width: calc(100% - 690px);
    text-align: right;
    margin-bottom: 10px;
  }
</style>
